import { useTranslation } from "react-i18next";

import { useGetFaqQuery } from "../app/api/private/faq";
import { FaqCategory } from "../app/models/FaqCategory";
import { Accordion } from "../features/shared/Accordion";
import { Container } from "../features/shared/Container";
import { Loader } from "../features/shared/Loader";
import { Paper } from "../features/shared/Paper";
import { Markdown } from "../features/shared/Markdown";
import { MainPage } from "./shared/MainPage";

import { ReactComponent as Icon } from "./FaqPageIcon.svg";
import "./FaqPage.scss";

const classNamePrefix = "FaqPage";

export const FaqPage = () => {
  const { currentData: faqData, error, isFetching } = useGetFaqQuery();

  return faqData ? (
    <FaqPageContent data={faqData} />
  ) : (
    <Loader error={error} isFetching={isFetching} />
  );
};

type FaqPageContentProps = { data: FaqCategory[] };

const FaqPageContent = (props: FaqPageContentProps) => {
  const { data: faqData } = props;

  const { t } = useTranslation();
  const { meta, title } = t("pages.FaqPage") as unknown as {
    meta: { title: string };
    title: string;
  };

  const hash = window.location.hash.slice(1);
  const hashItemId = hash.startsWith("faq-") ? hash.replace("faq-", "") : null;

  const categoryWithHashItem = hashItemId
    ? faqData.find((cat) => cat.items.some((item) => item.id === hashItemId))
    : null;

  return (
    <MainPage
      dataLayer={{
        categorie_page: "faq",
        nom_page: "faq",
        virtualpagetitle: "FAQ",
      }}
      icon={<Icon />}
      meta={meta}
      title={meta.title}
    >
      <Paper className={`${classNamePrefix}-title`}>
        <Markdown>{title}</Markdown>
      </Paper>
      <Container>
        <div className={`${classNamePrefix}-content`}>
          {faqData.map((category) => (
            <Accordion
              key={category.id}
              title={category.title}
              titleAs="h2"
              triggerLabel={`Expand ${category.title}`}
              className={`${classNamePrefix}-main-accordion`}
              defaultOpen={categoryWithHashItem?.id === category.id}
            >
              <div className={`${classNamePrefix}-sub-accordions`}>
                {category.items.map((item) => (
                  <div key={item.id} id={`faq-${item.id}`}>
                    <Accordion
                      title={item.question}
                      titleAs="h3"
                      triggerLabel={`Expand ${item.question}`}
                      className={`${classNamePrefix}-sub-accordion`}
                      defaultOpen={hashItemId === item.id}
                    >
                      <Paper className={`${classNamePrefix}-answer`}>
                        <div
                          dangerouslySetInnerHTML={{ __html: item.answer }}
                        />
                      </Paper>
                    </Accordion>
                  </div>
                ))}
              </div>
            </Accordion>
          ))}
        </div>
      </Container>
    </MainPage>
  );
};
